import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, switchMap, tap } from 'rxjs';
import { CalendarIntegrationDTO } from 'src/app/interfaces/calendarIntegration';
import { AppRegistrationService } from 'src/app/services/app-registration.service';
import { CalendarService } from 'src/app/services/calendar.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';

@Component({
  selector: 'app-callback',
  imports: [],
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
})
export class CallbackComponent implements OnInit {

  accessToken: string;
  code: string;
  state: string;
  scope: string;
  calendarIntegration: CalendarIntegrationDTO;

  constructor(private errorhandling: ErrorhandlingService, private route: ActivatedRoute, private router: Router, private appRegistrationService: AppRegistrationService, private calendarService: CalendarService) {
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.code = queryParams.get("code");
      this.state = queryParams.get("state");
      this.processCallBack(this.code, this.state).subscribe();

    });

    /*this.route.fragment.subscribe(fragment => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const accessToken = params.get("access_token");
        const state = params.get("state");

        if (accessToken) {
          this.processCallBack(accessToken, null, state).subscribe();
        }
      }
    });*/
  }

  processCallBack(code: string, state: string): Observable<any> {
    return this.appRegistrationService.callBack(code, state).pipe(

      tap({
        next: (data: any) => {
          this.calendarIntegration = data;
        }
      }),

      switchMap(() => {
        return this.calendarService.getCalendars(this.calendarIntegration.id, false);
      }),

      tap({
        next: () => {
          this.router.navigate(['/settings']);
        }
      }),

      catchError(error => {
        console.error("One of the API calls failed:", error);
        return EMPTY; // stop the stream
      })

    );
  }

}
